export const LOCAL_STORAGE_KEY_PREFIX = "beta-features-";
export const COOLDOWN_MIN_DURATION_DEFAULT = "10800";
export const TVG5_COOKIE = "useTvg5";
